import request from "../request";
import qs from 'qs'
import CryptoJs from 'crypto-js'
import { sendNationCaptchaName, companyInfo, NODE_API, FILEACTIONURL } from '../../config'

export const ListTransactionPublicityPaging = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/ListTransactionPublicityPaging',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getWebsiteProject = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getWebsiteProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getWebsiteHouse = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/houses/getWebsiteHouse',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getTransactionList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/list',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyTransactionLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/myTransactionList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const projectDetailInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/projectDetailInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getRoomTypeByProject = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getRoomTypeByProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const sendNationCaptcha = (params) => {
    return new Promise((resolve, reject) => {
        params.country = '86'
        params.productName = sendNationCaptchaName
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/captcha/sendNationCaptcha',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getUserProjectSummaryInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getUserProjectSummaryInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const doRegister = (params) => {
    return new Promise((resolve, reject) => {
        params.companyCode = companyInfo.companyCode
        params.companyName = companyInfo.companyName
        if (params.loginPwd) params.loginPwd = CryptoJs.MD5(trims(params.loginPwd)).toString()
        if (params.loginUser) params.loginUser = trims(params.loginUser)
        if (params.mobile) params.mobile = trims(params.mobile)
        if (params.username) params.username = trims(params.username)
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/register',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const checkCaptcha = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/captcha/verifyCaptcha',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const forgetPassword = (params) => {
    return new Promise((resolve, reject) => {
        if (params.loginPwd) params.loginPwd = CryptoJs.MD5(params.loginPwd).toString()
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/forgetPassword',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getAllProjectList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getAllProjectList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getProjectDetails = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/projectDetailInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const projectWebDetailInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/projectWebDetailInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUserProjectSummaryInfos = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getUserProjectSummaryInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyQueueLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/myQueueList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyReserveLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/myReserveList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUserBillLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/bills/getUserBillList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyReletApplyList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/signConfirm/myReletApplyList',
            // contracts/getReSignContract
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getSigningConfirmationDetail = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/signConfirm/getSigningConfirmationDetail',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getApplyEvictionList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/getApplyEvictionList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const applyReSignContract = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/contracts/applyReSignContract',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const reletApply = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/contracts/reletApply',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const evictionElectronicSignature = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/evictionElectronicSignature',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const evictionElectronicSignatureUrl = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/evictionElectronicSignatureUrl',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const evictionElectronicSignatureUrls = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/evictionInspect/evictionElectronicSignatureUrl',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyContracts = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/contracts/getMyContract',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getContractInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/contracts/getContractDetail',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getTransactionDetailById = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/getTransactionDetailById',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getApplyEvictionDateList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/getApplyEvictionDateList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getApplyEvictionDetail = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/getApplyEvictionDetail',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getSaveApplyEviction = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/getSaveApplyEviction',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getApplyTransactionCheck = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/applyTransactionCheck',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const printTransaction = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/printTransaction',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const repairMaterials = (params) => {
    return new Promise((resolve, reject) => {
        // const data = qs.stringify(params)
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transaction/repairMaterials',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getCollectProjects = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/collectProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMessages = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/message/list',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const progressQuery = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/progressQuery',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const myQueueList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/myQueueList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getApplyingTransaction = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/getApplyingTransaction',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const applyQueue = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/applyQueue',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const applyReserveRegister = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/applyReserveRegister',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const canReserveRegister = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/canReserveRegister',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUserHouseListInProject = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getUserHouseListInProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const userReserve = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/userReserve',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUpdateUser = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/updateUser',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCancelQueue = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/cancelQueue',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const cancelUserRelet = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/contracts/cancelUserRelet',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const cancelApplyEviction = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/cancelApplyEviction',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCancelReserve = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/reserves/cancelReserve',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const transactionApply = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transaction/apply',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setSaveTheBeforehand = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/saveTheBeforehand',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const transactionUpdate = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transaction/update',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setSaveOrCommitFlag = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/getSaveOrCommitFlag',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setToloadBeforeSaveData = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/toloadBeforeSaveData',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCompanyMenu = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/companys/getCompanyMenu',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCompanyInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/companys/getCompanyInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const generateTransitionResidenceApplication = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/contracts/generateTransitionResidenceApplication',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getTemplate = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/eviction/getTemplate',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setSaveOrCommitTimeByUserId = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/getSaveOrCommitTimeByUserId',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

// 上传图片
export const uploadFile = (params, obj) => {
    return new Promise((resolve, reject) => {
        console.log(params);
        // const data = qs.stringify(params)
        let fd = new FormData();    //定义参数
        // fd.append('file', params)
        // fd.append('output', obj.output)
        // fd.append('scene', obj.scene)
        // fd.append('suffix', obj.suffix)

        fd.append('xslFile', params)
        fd.append('suffix', obj.suffix.replace('.', ''))
        if (obj.flag === 1) {
            fd.append('flag', obj.flag)
        }
        request({
            url: FILEACTIONURL,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data;' },
            data: fd
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}


// tinifyAPI压缩图片
export const shrink = (params, obj) => {
    return new Promise((resolve, reject) => {
        console.log(params);
        // const data = qs.stringify(params)
        let fd = new FormData();    //定义参数
        fd.append('file', params)

        request({
            auth: {
                username: '18511999913@163.com',
                password: 'mlBm48sq4B1NmgtrppmykBfvHvqQdt9k'
            },
            url: 'https://api.tinify.com/shrink',
            method: 'post',
            data: fd
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 项目供应情况展示
export const getSupplyProject = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getSupplyProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getFilesList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/files/list',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

// 获取上次的资格证填写信息
export const getNearlyTransaction = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        console.log('data?????', data);
        request({
            url: NODE_API + '/transaction/getNearlyTransaction',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 获取资格证待办事项
export const getTransactionTodoList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/getTransactionTodoList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 获取资格证待办事项
export const perfectTransaction = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transaction/perfectTransaction',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const signingConfirmation = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/signConfirm/signingConfirmation',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 退租申请
export const applyEviction = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/eviction/applyEviction',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const editApplyEviction = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/eviction/editApplyEviction',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getTenantDirectCommonReplies = (params = {}) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/tenantDirect/commonReplies',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const submitTenantDirectQuestion = (params = {}) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/tenantDirect/add',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getTenantDirectMyList = (params = {}) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/tenantDirect/myList',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}